import { BACKEND_URL } from "./api";

// Object-storage photos are served from the backend under /api/; local
// /public assets (e.g. /urgent-rescues/x.jpg) are served by the frontend.
export const resolveMedia = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${(BACKEND_URL || "").replace(/\/+$/, "")}${url}`;
  return url;
};

export const rescuePublicUrl = (id) => `${window.location.origin}/urgent-rescues/${id}`;

export const isUnverified = (r) => (r?.verification || "").startsWith("Reported");
